export { default } from './Hero'


// WEBPACK FOOTER //
// ./src/components/Hero/index.js